export { default as MinusSolidIcon } from './MinusSolidIcon';
